<figure class="preview-container">
  @if (doors.length === 0) {
    <section class="loader-container">
      <ng-casto-loader></ng-casto-loader>
    </section>
  } @else {
    <ul class="layers">
      @for (door of doors; track door.id) {
        <li
          class="sublayer"
          [id]="'door' + door.id"
          [ngClass]="{ front: isInFront(door.id), rear: !isInFront(door.id) }"
          [ngStyle]="{
            'margin-left': isOffset(door.id) ? calculateOffset(door.id) : null,
          }">

          @if (door.layer) {
            <img [src]="baseImgURL + door.layer.layer" alt="" />
          }
        </li>
      }
    </ul>
  }
</figure>
<div class="preview-floor"></div>
